<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('subjectreportlist')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <br />
            <form>
                <v-col md="12">
                    <v-card elevation="4">
                        <div class="sticky-div">
                            <table style="border-collapse:collapse;">
                                <thead>
                                    <tr>
                                        <th class="header-cell col-sm-6 col-md-4 col-12">{{ $t("enterSubject") }}</th>
                                        <th class="header-cell col-sm-6 col-md-3 col-12">{{ $t("estimated_income") }}</th>
                                        <th class="header-cell col-sm-6 col-md-4 col-12">{{ $t("remarks") }}</th>
                                        <th class="header-cell col-sm-6 col-md-1 col-12">{{ $t("actions") }}</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div>
                            {{incomeSource}} {{subjectFormData.fiscalYearID}}
                            <v-row class="pt-3" v-for="(income, incomeIndex) in incomeSource.budgets" :key="incomeIndex" :style="getSubjectRowStyle(incomeIndex)">
                                <v-col md="4" sm="6" cols="12">
                                    <v-select v-model.number="income.subjectTitleID" outlined
                                              :items="subjectList"
                                              item-text="value"
                                              item-value="id">
                                        <template v-slot:label>
                                            {{ $t("enterSubject") }}
                                        </template>
                                    </v-select>

                                </v-col>
                                <v-col md="3" sm="6" cols="12">
                                    <v-text-field clearable
                                                  required
                                                  outlined
                                                  type="number"
                                                  v-model.number="income.amount">
                                        <template v-slot:label>
                                            {{ $t("estimated_income") }}
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col md="4" sm="6" cols="12">
                                    <v-text-field clearable
                                                  required
                                                  outlined
                                                  v-model="income.remarks">
                                        <template v-slot:label>
                                            {{ $t("remarks") }}
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col md="1" sm="6" cols="12">
                                    <v-icon @click="addIncomeSource" color="green" class="mr-2">
                                        mdi-plus
                                    </v-icon>
                                    <v-icon v-if="incomeSource.length != 1"
                                            @click="incomeSource.budgets.splice(incomeIndex, 1)"
                                            color="red">mdi-delete</v-icon>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-col>
            </form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">{{$t('cancel')}}</v-btn>
            <v-btn class="custom-save-button" @click="formSubmit">{{$t('save')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import axios from "axios";

    export default {
        name: "SubjectForm",
        components: {
        },
        props: ["subjectFormData"],
        data() {
            return {
                formData: {},
                message: {
                    status: true,
                    text: 'true',
                },
                subjectList: [],
                anusucharuList: [],
                fiscalYearList: [],
                isInitial: true,
                dialogDelete: false,
                anusichiViewModal: false,
                viewAnusuchiComponent: false,
                deleteFormData: {},
                aunusucharuData: {},
                report: {
                    fiscalYearID: 0,
                    anusucharuReportID: 0
                },
                incomeSource:
                    {
                    fiscalYearID: this.subjectFormData.fiscalYearID,
                        budgets: [
                            {
                                subjectTitleID: 0,
                                amount: 0,
                                remarks: "",
                            }
                        ]

                    },
                columns: [
                    {
                        label: "name",
                        field: "name"
                    },
                    {
                        label: "actions",
                        field: "actions",
                        sortable: false
                    }
                ],
                rows: [],
            }
        },
        computed: {
        },
        methods: {
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueClose')
            },
            searchAnusuchi() {
                this.anusichiViewModal = true
                this.viewAnusuchiComponent = true
                let model = {
                    fiscalYearID: this.report.fiscalYearID,
                    anusucharuReportID: this.report.anusucharuReportID,
                }
                this.aunusucharuData = model;

                this.viewAnusuchiComponent
                this.$refs.anusucharuReportView.loadItems();
            },
            dialogueCloseView() {
                this.anusichiViewModal = false
                this.viewAnusuchiComponent = false
            },
            getSubjectRowStyle(incomeIndex) {
                const colors = ['#d3d3d3', '#ede8e8', '#d8e6e7', '#e4e2f5', '#f5f2e2', '#c1d1cb', '#c1c8d1', '#c4c1d1', '#f7e4e4']; // Define the desired color codes
                const backgroundColor = colors[incomeIndex % colors.length];
                return `background-color: ${backgroundColor}; margin:auto`;
            },
            formSubmit() {
                axios.post('ReportSettings/InsertIncomeLevelTwo', this.incomeSource)
                    .then(() => {
                        this.message.status = true
                        this.message.text = 'Income is Successfully Updated'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
                    .catch(() => {
                        this.message.status = false
                        this.message.text = 'Error Adding income, Please Contact Admin'
                        this.$emit('formResponse', this.message)
                    })
            },
            formSubmitUpdate() {
                axios.post('ReportSettings/UpdateIncomeLevelTwo', this.incomeSource)
                    .then(() => {
                        this.message.status = true
                        this.message.text = 'Income is Successfully Updated'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
                    .catch(() => {
                        this.message.status = false
                        this.message.text = 'Error Adding income, Please Contact Admin'
                        this.$emit('formResponse', this.message)
                    })
            },
            async loadItems() {
                axios.get("ReportSettings/DDLIncomeSubjectTitleList").then(response => {
                    this.subjectList = response.data
                })
                axios.get("AnusucharuReport/AnusucharuList").then(response => {
                    this.anusucharuList = response.data
                })
            },
            onResponseDelete() {
                this.dialogDelete = false;
                this.checkAllFiscalYearData();
                this.clearForm();
            },
            addIncomeSource() {
                this.incomeSource.budgets.push({
                                subjectTitleID: 0,
                                amount: 0,
                                remarks: "",
                });
            },
            checkAllFiscalYearData() {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelTwoByID/" + this.subjectFormData.fiscalYearID).then(response => {
                    this.rows = response.data
                })
            },
            subjectInfo(item) {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelTwoByIDandSubjectID/" + item.fiscalYearID + "/" + item.subjectTitleID).then(response => {
                    this.incomeSource = response.data
                    this.isInitial = false
                })
            },
            clearForm() {
                this.incomeSource = [
                    {
                        fiscalYearID: this.subjectFormData.fiscalYearID,
                        subjectTitleID: 0
                    }
                ],
                    this.isInitial = true,
                    this.report.fiscalYearID= 0,
                    this.report.anusucharuReportID= 0
            },
            fiscalyear() {
                axios.get("ReportSettings/GetFiscalYearList").then(response => {
                    this.fiscalYearList = response.data
                })
            }
        },
        created() {
            this.loadItems()
            this.checkAllFiscalYearData()
            this.fiscalyear()

        },

    }
</script>

<style scoped>
</style>
